import { useState } from "react";

import { useSearchParams } from "react-router";

/**
 * useInitialSort
 *
 * Returns the initial sort value from the URL query string, or a provided default.
 * This hook is designed to capture the sort parameter only once on mount,
 * preventing duplicate data requests. Subsequent sort changes should be handled
 * by the table or grid's refetch logic.
 *
 * @param defaultSort - Fallback sort value if none is present in the URL - evaluated on mount.
 * @returns The initial sort value as a string.
 */
export function useInitialSort(defaultSort = "") {
  const [searchParams] = useSearchParams();

  // Capture the initial sort value from the URL only once on mount.
  const [order] = useState(() => searchParams.get("sort") || defaultSort);

  return order;
}
